import React from "react";
import "./dashBoard.css";
import BoxView from "../../components/BoxView";
import BorderVertical from "../../components/BorderVertical";
import BorderHorizontal from "../../components/BorderHorizontal";
import { Grid } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import TitleBoxView from "../TitleBoxView";
import DropDown from "../../components/Dropdown/index";
import PageTitle from "../PageTitle";
import { connect } from "react-redux";
import { statementsXlsDataRequest } from "../../actions/businessDataActions";

const download_icon = require("../../assets/icons/download_icon.svg");

function DineInDashboard(props) {
  const items = ["All time", "Last 90 days", "Last 30 days", "Last 7 days"];

  const handleExport = () => {
    const exportData = {
      product: "DINE_IN",
      order_by_desc: true,
      order_by: "invoicedAt",
      start_time: props.startTime,
      end_time: props.endTime
    };
    props.statementsXlsDataRequest(exportData);
  };

  return (
    <>
      <Grid
        container
        direction="column"
        justify="space-evenly"
        style={{ marginBottom: 50 }}
        className="old-mp-spacing"
      >
        <Grid container>
          <Grid item xs={12} sm={6}>
            <div style={{ marginBottom: 50, alignContent: "center" }}>
              <PageTitle pageTitle={"Business Statistics"} />
            </div>
          </Grid>
          <Grid item xs={12} sm={6} className="display-flex justify-content-right">
            <DropDown
              future={false}
              handleSelect={props.onSelectHandler}
              items={items}
              selectedOptionNumber={2}
            />
            <div 
              onClick={handleExport} 
              className={`display-flex align-items-center cursor-pointer smooth-click padding-top-bottom-15px ${props.isDownloadingStatements ? 'click-disabled' : ''}`} 
              style={{ color: "#4a586b", marginLeft: "20px", alignSelf: "flex-start" }}
            >
              <span className="font-weight-450" style={{ whiteSpace: "nowrap" }}>
                {props.isDownloadingStatements ? "Downloading" : "Export Results"}
                {props.isDownloadingStatements ? (
                  <>
                    <span className="dot">.</span>
                    <span className="dot">.</span>
                    <span className="dot">.</span>
                  </>
                ) : ''}
              </span>
              <img 
                style={{ padding: "5px", borderRadius: "50px", background: "white", marginLeft: "10px" }} 
                src={download_icon} 
                alt=""
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <TitleBoxView
              pageTitle="Revenue Driven"
              titleNumber={props.dashboardData.revenueDriven}
              hasDollars={true}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" justify="space-evenly">
          <BorderHorizontal />
          <Grid item container direction="row" justify="space-evenly">
            <Grid item style={{ paddingTop: 100 }}>
              <BoxView
                title="Average Spend Per Party"
                number={props.dashboardData.avgSpend}
                hasDollars={true}
              />
            </Grid>
            <Hidden smDown>
              <Grid item style={{ paddingTop: 30 }}>
                <BorderVertical />
              </Grid>
            </Hidden>
            <Grid item style={{ paddingTop: 100 }}>
              <BoxView
                title="Number of Parties Sent"
                number={props.dashboardData.numOfPartiesSent}
                hasDollars={false}
              />
            </Grid>
          </Grid>
        </Grid>
        <Hidden smDown>
          <Grid item>
            <BorderHorizontal />
          </Grid>
        </Hidden>
      </Grid>
    </>
  );
}

const mapStateToProps = state => ({
  isDownloadingStatements: state.businessData.isDownloadingStatements
});

const mapDispatchToProps = dispatch => ({
  statementsXlsDataRequest: data => dispatch(statementsXlsDataRequest(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(DineInDashboard);
